// noinspection SpellCheckingInspection

export type IMapField = {
    [id: string]: any;
};

type IDic = {
    [id: string]: string[];
};

export class MapAPIField {
    private _map: IDic = {
        // all
        createdAt: ['created_at'],
        deletedAt: ['deleted_at'],
        endDate: ['end_date'],
        fileType: ['file_type'],
        startDate: ['start_date'],
        iccId: ['iccid'],
        // user
        bytesPerKb: ['bytes_per_kb'],
        companyId: ['company_id', 'company'],
        currentPassword: ['current_password'],
        docsAcceptedAt: ['docs_accepted_at'],
        enabledAt: ['enabled_at'],
        failedLoginCount: ['failed_login_count'],
        firstName: ['first_name'],
        func: ['function'],
        hideCosts: ['hide_costs'],
        lastName: ['last_name'],
        latestAcceptedAt: ['latest_accepted_at'],
        mfaEnabledAt: ['mfa_enabled_at'],
        mfaToken: ['mfa_token'],
        outerAssignment: ['outer_assignment'],
        passwordConfirmation: ['password_confirmation'],
        passwordNew: ['password'],
        phoneNumber: ['phonenumber'],
        provisioningUri: ['provisioning_uri'],
        registration: ['c_registration'],
        requireTariff: ['show_package_data'],
        showPackageData: ['require_tariff'],
        totpRequired: ['totp_required'],
        userId: ['user_id'],
        userTypeId: ['user_type_id'],
        boughtForMyCompany: ['bought_for_my_company'],
        // cardInfo
        amountType: ['amount_type'],
        batchId: ['batch_id'],
        dispatchLock: ['dispatch_lock'],
        firstSeen: ['first_seen'],
        lastSeen: ['last_seen'],
        limitChangeAllowed: ['limit_change_allowed'],
        limitForSubCompaniesAllowed: ['limit_for_sub_companies_allowed'],
        plmnList: ['plmn_list'],
        printedId: ['printed_id'],
        roamingImsi: ['roaming_imsi'],
        statusNew: ['status_new'],
        statusOverall: ['status_overall'],
        suspenderCompanyId: ['suspender_company_id'],
        transactionError: ['transaction_error'],
        unitPrice: ['unit_price'],
        usageLimitUnit: ['usage_limit_unit'],
        usageLimit: ['new_usage_limit'],
        // Company
        actualDarkLogoUrl: ['actual_dark_logo_blob'],
        actualLogoUrl: ['actual_logo_blob'],
        addressBuilding: ['address_building'],
        addressNumber: ['address_number'],
        addressStreet: ['address_street'],
        alarmEmails: ['alarm_emails'],
        billingEmails: ['billing_emails'],
        billingToDepartment: ['billing_to_department'],
        cardLimit: ['card_limit'],
        cardsCount: ['cards_count'],
        cardSetIds: ['card_set_ids'],
        cardSetLimit: ['card_set_limit'],
        cardSetTotalIds: ['card_set_total_ids'], // cardSetRecordMap
        cardSetTotalLimit: ['card_set_total_limit'], // cardSetRecordMap
        cdrSquashInterval: ['cdr_squash_interval'],
        companyName: ['company_name'],
        companyParentId: ['company_parent_id'],
        companyParentName: ['company_parent_name'],
        companyTypeId: ['company_type_id', 'company_type'],
        companyTypeName: ['company_type_name'],
        customAboutEnabled: ['custom_about_enabled'],
        customerPrivacy: ['customer_privacy'],
        customLogoLinkUrl: ['custom_logo_link_url'],
        darkLogoBlobId: ['dark_logo_blob_id'],
        darkLogoUrl: ['dark_logo_blob'],
        externalId: ['external_id'],
        financialContactId: ['financial_contact_id'],
        helpDeskEnabled: ['help_desk_enabled'],
        invoicedByCompanyId: ['invoiced_by_company_id'],
        logoBlobId: ['logo_blob_id'],
        logoUrl: ['logo_blob'],
        mfaForcedBy: ['mfa_forced_by'],
        parentId: ['parent_id', 'parent'],
        paymentTerms: ['overdue_period'],
        billingCycleStartDay: ['billing_cycle_start_day'],
        paymentTypeId: ['payment_type_id', 'payment_type'],
        paymentTypeName: ['payment_type'],
        primaryContactId: ['primary_contact_id'],
        privacyCdr: ['privacy_cdr'],
        rateId: ['rate_id'],
        salesRateList: ['sales_rate_list', 'apply_company_sales_rate_lists'],
        sessionGrantedTypeId: ['session_granted_type_id', 'session_granted_type'],
        sessionGrantedUnit: ['session_granted_unit'],
        sessionValidityTime: ['session_validity_time'],
        spendingLimit: ['spending_limit'],
        subscribersAmount: ['subscribers_amount'],
        subscribersCsvBlobId: ['subscribers_csv_blob_id'],
        subscribersOnPremAmount: ['subscribers_on_prem_amount'],
        subtreeIds: ['subtree_ids'],
        technicalContactId: ['technical_contact_id'],
        thresholdHigh: ['threshold_high'],
        thresholdMedium: ['threshold_medium'],
        vatNumber: ['vat_number'],
        vatPercentage: ['vat_percentage'],
        whiteLabel: ['whitelabel'],
        zeroCostData: ['zero_cost_data'],
        zeroCostSms: ['zero_cost_sms'],
        zeroCostVoice: ['zero_cost_voice'],
        zipCode: ['zip_code'],
        // Sales Rate List
        assignedCompanies: ['assigned_company'],
        calculatedRateData: ['calculated_rate_data'],
        calculatedRateSms: ['calculated_rate_sms'],
        calculatedRateVoiceMobile: ['calculated_rate_voice_mobile'],
        calculatedRateVoiceNet: ['calculated_rate_voice_net'],
        countryId: ['country_id', 'country'],
        currencyId: ['currency_id', 'currency'],
        defaultRateData: ['default_rate_data'],
        defaultRateDataUnitId: ['default_rate_data_unit_id', 'default_rate_data_unit'],
        defaultRateSms: ['default_rate_sms'],
        defaultRateSmsUnitId: ['default_rate_sms_unit_id', 'default_rate_sms_unit'],
        defaultRateVoiceMobile: ['default_rate_voice_mobile'],
        defaultRateVoiceNet: ['default_rate_voice_net'],
        mrcActiveCard: ['mrc_active_card'],
        mrcActiveImsi: ['mrc_active_imsi'],
        mrcCard: ['mrc_card'],
        networkId: ['network_id', 'network'],
        nrcCard: ['nrc_card'],
        nrcImsi: ['nrc_imsi'],
        operatorId: ['operator_id', 'operator'],
        operatorName: ['operator_name'],
        rateData: ['rate_data'],
        rateDataUnitId: ['rate_data_unit_id', 'rate_data_unit'],
        rateSms: ['rate_sms'],
        rateSmsUnitId: ['rate_sms_unit_id', 'rate_sms_unit'],
        rateVoiceMobile: ['rate_voice_mobile'],
        rateVoiceMobileUnitId: ['rate_voice_mobile_unit_id', 'rate_voice_mobile_unit'],
        rateVoiceNet: ['rate_voice_net'],
        rateVoiceNetUnitId: ['rate_voice_net_unit_id', 'rate_voice_net_unit'],
        incrementData: ['increment_data'],
        // Purchase Rate List
        incrementVoiceMobile: ['increment_voice_mobile'],
        incrementVoiceNet: ['increment_voice_net'],
        purchaseRateListEntry: ['purchase_rate_list_entry'],
        // DiameterSessions
        ccRequestNumber: ['cc_request_number'],
        ccRequestType: ['cc_request_type'],
        eventTimestamp: ['event_timestamp'],
        salesRateListEntry: ['sales_rate_list_entry'],
        sessionId: ['session_id'],
        sgsnMccMnc: ['sgsn_mcc_mnc'],
        totalUsedUnits: ['total_used_units'],
        // Card Sets
        activeSubscribersCount: ['active_subscribers_count'],
        cardId: ['card_id', 'card'],
        cardName: ['card_name'],
        cardSetId: ['card_set_id'],
        cardSet: ['card_set'],
        nonExpirable: ['non_expirable'],
        combinationCardSetCards: ['card_combinations', 'card_combination'],
        dataUnits: ['data_units'],
        isActive: ['is_active'],
        isDeletable: ['is_deletable'],
        originalUnitsSum: ['original_units_sum'],
        shortId: ['short_id'],
        subscribersCount: ['subscribers_count'],
        // CallDataRecord metadata
        billedAsPackage: ['billed_as_package'],
        callAniUsed: ['call_ani_used'],
        callCostBuy: ['call_cost_buy'],
        callCurrency: ['call_currency'],
        callDir: ['call_dir'],
        calledStationId: ['called_station_id'],
        callIpAddress: ['call_ip_address'],
        callKey: ['call_key'],
        callPriceSell: ['call_price_sell'],
        callProt: ['call_prot'],
        callRounding: ['call_rounding'],
        callStart: ['call_start'],
        callStation: ['call_station'],
        callType: ['call_type'],
        callUnits: ['call_units'],
        callUnitType: ['call_unit_type'],
        moRoamLoc: ['mo_roam_loc'],
        moRoamNumb: ['mo_roam_numb'],
        msisdnA: ['msisdn_a'],
        msisdnB: ['msisdn_b'],
        mtRoamLoc: ['mt_roam_loc'],
        mtRoamNumb: ['mt_roam_numb'],
        visitedPlmn: ['visited_plmn'],
        // Operator
        guestRecordsCount: ['guest_records_count'],
        hostRecordsCount: ['host_records_count'],
        // BalanceLog
        balanceAfter: ['balance_after'],
        balanceBefore: ['balance_before'],
        productTypeId: ['product_type_id', 'product_type'],
        RatedCallDataRecord: ['rated_call_data_record'],
        transactionId: ['transaction_id'],
        updatedAt: ['updated_at'],
        // SubscriberAPIRequest
        accountId: ['accountid'],
        accountNumber: ['accountnumber'],
        allowBillShockSMS: ['allowbillshocksms'],
        allowData: ['allowdata'],
        allowDataOverUsage: ['allowdataoverusage'],
        allowDataRoaming: ['allowdataroaming'],
        allowPremiumSMS: ['allowpremiumsms'],
        billShockActive: ['billshockactive'],
        billShockRelease: ['billshockrelease'],
        billShockTrigger: ['billshocktrigger'],
        bundleProductId: ['bundleproductid'],
        bundleProductName: ['bundleproductname'],
        bundleProductStartDate: ['startdate'],
        bundleProductType: ['bundleproducttype'],
        bundleStartOrderId: ['startbundleorderid'],
        deviceInfo: ['device_info'],
        numberListRequestId: ['numberlistrequestid'],
        orderDate: ['orderdate'],
        orderNumber: ['iccordernumberid', 'ordernumber'],
        orderReference: ['orderreference'],
        orderStatusId: ['orderstatusid'],
        orderType: ['ordertype'],
        outboundChannel: ['outbound_channel'],
        simCards: ['simcards'],
        simType: ['simtype'],
        subscriptionId: ['subscriptionid'],
        // DeviceAttribute
        allocationDate: ['allocation_date'],
        brandDetails: ['brand_details'],
        brandName: ['brand_name'],
        deviceModelName: ['device_model_name'],
        deviceType: ['device_type'],
        marketingName: ['marketing_name'],
        nonRemovableEuicc: ['nonremovable_euicc'],
        nonRemovableUicc: ['nonremovable_uicc'],
        operatingSystem: ['operating_system'],
        organisationId: ['organisation_id'],
        removableEuicc: ['removable_euicc'],
        removableUicc: ['removable_uicc'],
        simSlot: ['sim_slot'],
        // Notifications
        importTime: ['import_time'],
        lastImei: ['last_imei'],
        lockImei: ['lock_imei'],
        monthlyCost: ['monthly_cost'],
        salesRateListId: ['sales_rate_list_id'],
        salesRateListName: ['sales_rate_list_name'],
        // EsNotifications
        notificationPointId: ['notification_point_id'],
        notificationPointStatus: ['notification_point_status'],
        profileType: ['profile_type'],
        resultData: ['result_data'],
        // FeatureFlag
        allowImpersonate: ['allow_impersonate'],
        allowOperatorInteractions: ['allow_operator_interactions'],
        assetAssignmentCdrExport: ['asset_assignment_cdr_export'],
        clickhouseStatistics: ['clickhouse_statistics'],
        companyHierarchyV2: ['company_hierarchy_v2'],
        createTariffs: ['create_tariffs'],
        deserializerDisabled: ['deserializer_disabled'],
        exposedCdrsMetadata: ['exposed_cdrs_metadata'],
        exposeValidationErrors: ['expose_validation_errors'],
        newAlarms: ['new_alarms'],
        newCdrsRepo: ['new_cdrs_repo'],
        newChargingSystem: ['new_charging_system'],
        newResponseFormat: ['new_response_format'],
        newResponseFormatCountries: ['new_response_format_countries'],
        readBigTablesFromReplica: ['read_big_tables_from_replica'],
        showAllCardsInCardSet: ['show_all_cards_in_card_set'],
        showIntermediateCdr: ['show_intermediate_cdr'],
        subscribersFeatures: ['subscribers_features'],
        topUp: ['top_up'],
        useBigquery: ['use_bigquery'],
        v3CsvExporter: ['v3_csv_exporter'],
        v3PdfExporter: ['v3_pdf_exporter'],
        viewTariffs: ['view_tariffs'],
        newReportsPage: ['new_reports_page'],

        // use_bigquery
        cardsRatio: ['cards_ratio'],
        costRatio: ['cost_ratio'],
        unitType: ['unit_type'],
        volumeRatio: ['volume_ratio'],
        currencyAbbreviation: ['currency_abbreviation'],
        // Invoices
        buyerId: ['buyer_id'],
        deductFromBalance: ['deduct_from_balance'],
        fileUrl: ['file_url'],
        invoiceDate: ['invoice_date'],
        invoiceIteration: ['invoice_iteration'],
        pdfFileStatus: ['pdf_file_status'],
        sellerId: ['seller_id'],
        sendInvoice: ['send_invoice'],
        sendInvoiceOnDate: ['send_invoice_on_date'],
        sentAt: ['sent_at'],
        // Order
        invoicingCompany: ['invoicing_company'],
        linkedOrders: ['linked_orders'],
        linkedOrdersCount: ['linked_orders_count'],
        periodEnd: ['period_end'],
        periodStart: ['period_start'],
        purchaseOrderNumber: ['purchase_order_number'],
        statusManual: ['status_manual'],
        usageProducts: ['usage_products'],
        // Other
        activeThisMonth: ['active_this_month'],
        amountCents: ['amount_cents'],
        assignedCompaniesCount: ['assigned_companies_count'],
        balanceDifference: ['balance_difference'],
        cardCombinationId: ['card_combination_id'],
        chargeType: ['charge_type'],
        chargingCharacteristics: ['charging_characteristics'],
        chargingId: ['charging_id'],
        companiesPackages: ['companies_packages'],
        companyIds: ['company_ids'],
        countryIds: ['country_ids'],
        creditRemains: ['credit_remains'],
        dataVolume: ['data_volume'],
        dataVolumeByte: ['data_volume'],
        dataVolumeInUnit: ['new_data_volume'],
        dataVolumePercentageUsage: ['data_volume_percentage_usage'],
        dataVolumeUnit: ['data_volume_unit'],
        deviceName: ['device_name'],
        dialCode: ['dial_code'],
        dueDate: ['due_date'],
        errorMessage: ['error_message'],
        finalProfileStatusIndicator: ['final_profile_status_indicator'],
        geolocationEditable: ['geolocation_editable'],
        geolocationEnabled: ['geolocation_enabled'],
        geotrackingEnabled: ['geotracking_enabled'],
        ggsnAddress: ['ggsn_address'],
        hashInfo: ['hash_info'],
        imsiMccNnc: ['imsi_mcc_mnc'],
        lockedImei: ['locked_imei'],
        lockerId: ['locker_id'],
        logableId: ['logable_id'],
        matchingId: ['matching_id'],
        monthDuration: ['month_duration'],
        multipleServicesCreditControl: ['multiple_services_credit_control'],
        networkIds: ['network_ids'],
        notDestroyed: ['not_destroyed'],
        onPremMigrated: ['on_prem_migrated'],
        operationId: ['operation_id'],
        operationName: ['operation_name'],
        operatorCdrId: ['operator_cdr_id'],
        operatorIds: ['operator_ids'],
        orderableId: ['orderable_id'],
        orderableType: ['orderable_type'],
        originStateId: ['origin_state_id'],
        outOfBundle: ['out_of_bundle'],
        packagesCountries: ['packages_countries'],
        packagesNetworks: ['packages_networks'],
        packagesOperators: ['packages_operators'],
        packageType: ['package_type'],
        paymentUrl: ['payment_url'],
        pdpAddress: ['pdp_address'],
        pdpContextType: ['pdp_context_type'],
        planType: ['plan_type'],
        predefinedType: ['predefined_type'],
        priceCents: ['price_cents'],
        processingErrors: ['processing_errors'],
        productableId: ['productable_id'],
        productableType: ['productable_type'],
        productId: ['product_id'],
        ratingGroup: ['rating_group'],
        reasonCode: ['reason_code'],
        reportingReason: ['reporting_reason'],
        roamingPackagesCount: ['roaming_packages_count'],
        sgsnAddress: ['sgsn_address'],
        smdpAddress: ['smdp_address'],
        smsVolume: ['sms_volume'],
        smsVolumePercentageUsage: ['sms_volume_percentage_usage'],
        subjectCode: ['subject_code'],
        subjectIdentifier: ['subject_identifier'],
        subscriptionIdValue: ['subscription_id_value'],
        targetType: ['target_type'],
        tariffId: ['tariff_id'],
        tariffPackage: ['tariff_package'],
        tariffPackageId: ['tariff_package_id'],
        tariffPackageIds: ['tarrif_package_ids'],
        tariffPackages: ['tariff_packages'],
        tariffsCount: ['tariffs_count'],
        totalCount: ['total_count'],
        totalErrors: ['total_errors'],
        totalSaved: ['total_saved'],
        unitsAfter: ['units_after'],
        unitsBefore: ['units_before'],
        usedServiceUnit: ['used_service_unit'],
        userEquipmentInfoValue: ['user_equipment_info_value'],
        userIds: ['user_ids'],
        voiceVolume: ['voice_volume'],
        voiceVolumePercentageUsage: ['voice_volume_percentage_usage'],
        zipFile: ['zip_file'],
        zoneId: ['zone_id', 'zone'],
        // PaperTrail
        controllerAction: ['controller_action'],
        controllerName: ['controller_name'],
        itemType: ['item_type'],
        itemId: ['item_id'],
        actionId: ['action_id'],
    };

    public getUiField(apiField: string): string {
        return Object.entries(this._map).find(([key, vals]) => !!key && vals.includes(apiField))?.[0] || apiField;
    }

    public getApiField(uiField: string): string {
        const values: string[] = this._map[uiField] || [];
        return values[0] || uiField;
    }
}

export const uiFieldsIsNumber = [
    'billingCycleStartDay',
    'calculatedRateData',
    'calculatedRateSms',
    'calculatedRateVoiceMobile',
    'calculatedRateVoiceNet',
    'cdrSquashInterval',
    'costRatio',
    'defaultRateData',
    'defaultRateSms',
    'defaultRateVoiceMobile',
    'defaultRateVoiceNet',
    'incrementData',
    'incrementVoiceMobile',
    'invoicedByCompanyId',
    'rateData',
    'rateSms',
    'rateVoiceMobile',
    'rateVoiceNet',
    'sessionGrantedUnit',
    'sessionValidityTime',
    'spendingLimit',
    'thresholdHigh',
    'thresholdMedium',
    'usageLimit',
    'volumeRatio',
];

export const apiFieldsIsNumber = [
    'billingCycleStartDay',
    'cdrSquashInterval',
    'cost',
    'dataVolume',
    'dataVolumeByte',
    'dataVolumeInUnit',
    'duration',
    'incrementData',
    'incrementVoiceMobile',
    'incrementVoiceNet',
    'invoicedByCompanyId',
    'paymentTypeId',
    'price',
    'priceCents',
    'productTypeId',
    'sessionGrantedUnit',
    'sessionValidityTime',
    'usageLimit',
];

type IApiType = string | number | boolean | null;
type IUiType = string | number | boolean | undefined;

export const api2UiValue = (field: string, value: IApiType): IUiType => {
    // if (!!value && uiFieldsIsNumber.includes(field) && !isNaN(Number(value))) {
    //     return field === 'usageLimit' ? Number(value) / 1000 : Number(value);
    // } else
    if (value === null) {
        return undefined;
    } else {
        return value;
    }
};

const ui2ApiValue = (field: string, value: IUiType): IApiType => {
    if (typeof value === 'boolean') {
        return value;
    } else if (!value && typeof value !== 'number') {
        return null;
    } else if (typeof value === 'number') {
        if (apiFieldsIsNumber.includes(field)) {
            return value;
        } else {
            return value.toString();
        }
    } else {
        if (apiFieldsIsNumber.includes(field)) {
            if (!isNaN(Number(value))) {
                return Number(value);
            } else {
                console.warn(`Field: ${field} value: "${value}" is not a number!`);
                return null;
            }
        } else {
            return value;
        }
    }
};

export const mapUi2ApiField = (ui: IMapField): IMapField => {
    const mapField = new MapAPIField();
    const api: IMapField = {};
    Object.entries(ui).forEach(([key, value]) => {
        api[mapField.getApiField(key)] = ui2ApiValue(key, value);
    });
    return api;
};

export const mapApi2UiField = (api: IMapField): IMapField => {
    const mapField = new MapAPIField();
    const ui: IMapField = {};
    Object.entries(api).forEach(([key, value]) => {
        const uiName = mapField.getUiField(key);
        ui[uiName] = api2UiValue(uiName, value);
    });
    return ui;
};

export const mapApi2UiList = (list: IMapField[] = []): IMapField[] => {
    return list
        .map((i) => mapApi2UiField(i))
        .map((i) => {
            const ui: IMapField = {};
            Object.entries(i).forEach(([key, value]) => {
                ui[key] = Array.isArray(value) ? mapApi2UiList(value) : value;
            });
            return ui;
        });
};

export const getUiField = (apiField: string): string => {
    const mapField = new MapAPIField();
    return mapField.getUiField(apiField);
};

export const getApiField = (uiField: string): string => {
    const mapField = new MapAPIField();
    return mapField.getApiField(uiField);
};

export const cleanPathFields = <T>(formFields: T, initFields: IMapField, blackList: Array<string> = []): T => {
    return Object.fromEntries(
        Object.entries(formFields as any).filter(
            ([key, value]) => blackList.includes(key) || initFields[key] !== value,
        ),
    ) as T;
};
